//右边搜索下拉
export const searchArr = [
  {
    key: "leader",
    title: "负责人",
  },
  {
    key: "phone",
    title: "联系电话",
  },
];

export const fields = [
  {
    dataIndex: "label",
    key: "label",
    title: "组织名称",
    width: 180,
    isShow: true,
  },
  {
    dataIndex: "orderNum",
    key: "orderNum",
    title: "排序",
    width: 180,
    isShow: true,
  },
  {
    dataIndex: "num",
    key: "num",
    title: "用户数",
    width: 180,
    isShow: true,
  },
  {
    dataIndex: "createTime",
    key: "createTime",
    title: "创建时间",
    isShow: true,
  },
  {
    title: "操作",
    key: "action",
    fixed: "right",
    width: 200,
    isShow: true,
    scopedSlots: {
      customRender: "action",
    },
  },
];
export const slotOpt = [
  {
    slot: "action",
    component: "Action",
    list: [
      { name: "编辑", cb: "edit", divider: false },
      { name: "新增", cb: "add", divider: true },
      { name: "删除", cb: "singleDelete", divider: true },
    ],
  },
];
